/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  EventEmitter,
  Output
} from '@angular/core';

import { Logger                } from '@/util/logger';

import * as $ from 'jquery';

@Component({
  standalone: false,
  templateUrl: 'overwatch.component.html'
})


/**
 *
 * @class OverwatchComponent
 *
 * @brief splash / landing page, what user's get when they login.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class OverwatchComponent implements OnInit, AfterViewInit, OnDestroy {

  /** standard constructor */
  constructor(
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[OverwatchComponent] init...');


  }

  ngAfterViewInit() {

    Logger.debug('[OverwatchComponent] after view init...');

    /* the component is up...try to get the data for building an overview map ... */


  }

  ngOnDestroy() {


  }

}

